import Action from "./action";

export default class NoOperation extends Action {
    constructor(props) {
        super(props);
    }

    async execute() {}
}
